module.exports = __webpack_public_path__ + "img/twitter.90a92d62.png";